const SelectAll = {
  data() {
    return {
      selected: [],
    }
  },
  computed: {
    selectAll: {
      get() {
        return this.selected.length === this.resources.length
      },
      set(value) {
        var selected = []
        if (value) {
          this.resources.forEach(function (i) {
            selected.push(i.id)
          })
        }
        this.selected = selected
      },
    },
  },
  methods: {
    select(e) {
      if (e.target.checked) {
        this.selected.push(Number(e.target.value))
      } else {
        var index = this.selected.indexOf(Number(e.target.value))
        if (index > -1) {
          this.selected.splice(index, 1)
        }
      }
    },
  },
}

export default SelectAll
